export default "__VITE_ASSET__CjoWCiv___"